<div>
    <div class="mh-64">
        <app-epa-input label="Password" [control]="password" type="password" [showEye]="true" (focus)="onFocus()" (focusOut)="onFocusOut()">
        </app-epa-input>
    </div>
    <div *ngIf="showToolTips" class="form-group">
        <div class="col-xs-1"></div>
        <div class="col-xs-11">
            <h6>Password Strength</h6>
            <div class="text-left m-b-sm m-t-sm">
                <label class="k-form-field">
                    <input type="checkbox" id="minLower" class="k-checkbox" [(ngModel)]="minLowerVerified" disabled>
                    <label class="k-checkbox-label" for="minLower"> Minimum 1 lowercase letter has been met</label>
                </label>
            </div>
            <div class="text-left m-b-sm m-t-sm">
                <label class="k-form-field">
                    <input type="checkbox" id="minUpper" class="k-checkbox" [(ngModel)]="minUpperVerified" disabled>
                    <label class="k-checkbox-label" for="minUpper"> Minimum 1 uppercase letter has been met</label>
                </label>
            </div>
            <div class="text-left m-b-sm m-t-sm">
                <label class="k-form-field">
                    <input type="checkbox" id="minNumeric" class="k-checkbox" [(ngModel)]="minNumericVerified" disabled>
                    <label class="k-checkbox-label" for="minNumeric"> Minimum 1 numeric has been met</label>
                </label>
            </div>
            <div class="text-left m-b-sm m-t-sm">
                <label class="k-form-field">
                    <input type="checkbox" id="minSymbol" class="k-checkbox" [(ngModel)]="minSymbolVerified" disabled>
                    <label class="k-checkbox-label" for="minSymbol"> Minimum 1 symbol has been met</label>
                </label>
            </div>
            <div class="text-left m-b-sm m-t-sm">
                <label class="k-form-field">
                    <input type="checkbox" id="minLength" class="k-checkbox" [(ngModel)]="minLengthVerified" disabled>
                    <label class="k-checkbox-label" for="minLength"> Minimum 6 characters has been met</label>
                </label>
            </div>
        </div>
    </div>
    <div class="mh-64" *ngIf="withConfirmation">
        <app-epa-input label="Confirm Password" [control]="confirmPassword" [showEye]="true" type="password">
        </app-epa-input>
    </div>
</div>